import React, { Component, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import * as router from 'react-router-dom';
import { Container } from 'reactstrap';
import {connect} from 'react-redux'

import {
  AppAside,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav,
} from '@coreui/react';
// sidebar nav config
import navigation, { student_nav, admin_nav, course_nav, content_nav, course_content_nav } from '../../_nav';
// routes config
import routes from '../../routes';
import { LOGIN_STATUS_REQUIRED } from '../../Reducers/AuthorizationReducer';
import { CheckLogin_ACTION } from '../../Actions/AuthorizationActions';
import { Routes } from '../../Services/API';
import { GetListAttempt_ACTION } from '../../Actions/LogisticActions';

const DefaultAside = React.lazy(() => import('./DefaultAside'));
const DefaultFooter = React.lazy(() => import('./DefaultFooter'));
const DefaultHeader = React.lazy(() => import('./DefaultHeader'));

class DefaultLayout extends Component {
  constructor(props){
    super(props)

    this.state = {
      rolesIndex:0,
      roles: []
    }
}

  loading = () => <div className="animated fadeIn pt-1 text-center">Loading...</div>

  signOut(e) {
    e.preventDefault()
    this.props.history.push('/login')
  }

  componentDidMount(){
    this.props.CheckLogin()

   
  }

  componentWillReceiveProps(){
    this.setState({
      roles:this.props.roles
    })
  }



  render() {
    if(!this.props.IsStudent && this.props.LoginStatus == LOGIN_STATUS_REQUIRED)
    {
      return(
        <Redirect from="/" to="/login" />
      )
    }

    let role = this.props.roles.reduce((p,a) => p += a, '')

    let nav_matrix = {
      'student': student_nav,
      'admin': admin_nav,
      'course_editor':course_nav,
      'content_editor':content_nav,
      'course_editorcontent_editor': course_content_nav,
      'content_editorcourse_editor': course_content_nav,

    }

    let nav = nav_matrix[role]
    
    if(this.props.roles.includes('course_editor')){
      if(this.props.GetError){

      }
      console.log("nav['items'][4]['children']")
      console.log(nav['items'][4]['children'])

      if(nav['items'][4]['children'].length != this.props.Courses.length + 3){

        nav['items'][4]['children'] = 
        [...nav['items'][4]['children'],
         ...(this.props.Courses.map((c) => ({
            name: c.Name,
            url: '/Courses/CourseView/' + c.Id,
            icon: 'icon-info',
        })))]

      }

    }

    return (
      <div className="app">
        <AppHeader fixed>
          <Suspense  fallback={this.loading()}>
            <DefaultHeader />
          </Suspense>
        </AppHeader>
        <div className="app-body" >
          <AppSidebar fixed display="lg" minimized>
            <AppSidebarHeader />
            <AppSidebarForm />
            <Suspense>
            <AppSidebarNav navConfig={nav} {...this.props} router={router}/>
            </Suspense>
            <AppSidebarFooter />
            <AppSidebarMinimizer />
          </AppSidebar>
          <main className="main" style = {{height:10}}>
            <AppBreadcrumb appRoutes={routes} router={router}/>
            <Container fluid>
              <Suspense fallback={this.loading()}>
                <Switch>
                  {routes.map((route, idx) => {
                    return route.component ? (
                      <Route
                        key={idx}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        render={props => (
                          <route.component {...props} />
                        )} />
                    ) : (null);
                  })}
                  <Redirect from="/" to="/dashboard" />
                </Switch>
              </Suspense>
            </Container>
          </main>
          <AppAside fixed>
            <Suspense fallback={this.loading()}>
              <DefaultAside />
            </Suspense>
          </AppAside>
        </div>
        <AppFooter>
          <Suspense fallback={this.loading()}>
            <DefaultFooter />
          </Suspense>
        </AppFooter>
      </div>
    );
  }
}

//Constant
const COURSES_SEARCHING_PARAMETER = 'IsMyCoursesSearching'
const COURSES_IS_ADDING_PARAMTER = 'IsMyCoursesAdding'

const COURSES_DATA_PARAMETER = 'MyCourses'

const COURSES_GET_ERROR_PARAMETER = 'MyCoursesGetError'
const COURSES_ADD_ERROR_PARAMETER = 'MyCoursesAddError'

function MapStateToProps(state) {
    return {
      LoginStatus:state.Authorization.LoginStatus,
      Token: state.Authorization.token,
      IsStudent: state.Authorization.student,
      roles: state.Authorization.roles,
      Courses:state.Query[COURSES_DATA_PARAMETER],
      IsSearching: state.Query[COURSES_SEARCHING_PARAMETER],
      GetError: state.Query[COURSES_GET_ERROR_PARAMETER],
    }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
          CheckLogin: () => {dispatch(CheckLogin_ACTION())},

          GetMyCourses: () => {dispatch(GetListAttempt_ACTION({
            SearchParameter: COURSES_SEARCHING_PARAMETER,
            DataParameter: COURSES_DATA_PARAMETER,
            GetErrorParameter: COURSES_GET_ERROR_PARAMETER,
            Path: Routes.GetAllMyCourses,
    
            [COURSES_IS_ADDING_PARAMTER]: false,
            [COURSES_SEARCHING_PARAMETER]: true,
            
            [COURSES_DATA_PARAMETER]: [],
    
            [COURSES_GET_ERROR_PARAMETER]: '',
            [COURSES_ADD_ERROR_PARAMETER]: ''
        }))}
    }
  }
  
export default connect(MapStateToProps, MapDispatchToProps)(DefaultLayout)


